import type { StepConfig } from '@/router/types';

const stepConfig: StepConfig = {
  path: 'vorgaben',
  routeName: 'input',

  props: {
    icon: 'pencil-alt',
    label: '1 Vorgaben',
  },
};

export default stepConfig;
